import type { ListSupportParams } from './api/supportApi';

export const supportKeys = {
  all: ['support'] as const,
  lists: () => [...supportKeys.all, 'list'] as const,
  list: (params: ListSupportParams) => [...supportKeys.lists(), normalize(params)] as const,
  safety: (limit?: number) => [...supportKeys.all, 'safety', limit ?? null] as const,
  stats: () => [...supportKeys.all, 'stats'] as const,
  detail: (ticketId: string) => [...supportKeys.all, 'detail', ticketId] as const,
};

function normalize(p: ListSupportParams) {
  return {
    limit: p.limit ?? null,
    cursor: p.cursor ?? null,
    status: p.status ?? null,
    type: p.type ?? null,
    priority: p.priority ?? null,
  } as const;
}
